<template>
  <div>
    <v-container
      grid-list-xl
      fluid
      class="white pl-6 pr-5"
      :class="page !== 'report' ? 'pt-6' : ''"
    >
      <v-layout row wrap class="pr-5 pl-2">
        <v-flex class="py-0">
          <h2 class="primary--text breadcrumbs fs-16 lh-29 font-weight-700">
            {{ page === 'budgeting' ? 'Budget' : 'Spending' }}
            {{ page == 'approval' ? 'Approval' : 'Report' }}
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-breadcrumbs
          class="px-0 fs-12 lh-15 py-0 breadcrumbs-items custom-breadcrumbs"
          :items="breadcrumbs"
        ></v-breadcrumbs>
        <v-flex xs12 class="pa-0 grey--text font-weight-500 fs-12 lh-16">
          <v-row class="px-3">
            <v-expansion-panels flat class="filterby-info">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="primary--text fs-13 px-0 pl-3 pt-0 pb-1"
                  height="100px"
                >
                  Filter By Information
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey--text">
                  <ul v-if="filterBy.length > 0">
                    <li
                      v-for="(filter, indexFilter) in filterBy"
                      :key="'filter' + indexFilter"
                      class="text-left"
                    >
                      {{ yearInfo }}
                      <template v-for="(detail, indexDetail) in filter">
                        {{ ' / ' }}
                        <span :key="'indexDetail-' + indexDetail">
                          {{ detail.map(e => e.name).join(' / ') }}
                        </span>
                      </template>
                    </li>
                  </ul>
                  <ul v-else>
                    <li>{{ yearInfo }}</li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-flex>
      </v-layout>
      <!-- summary total amount -->
      <v-layout row wrap class="px-5" v-if="page === 'report'">
        <v-expansion-panels
          flat
          v-model="panelSummary"
          multiple
          class="summary-collapse rounded-0"
          :class="panelSummary.length > 0 ? '' : 'border-y-2'"
        >
          <v-expansion-panel class="rounded-0">
            <v-expansion-panel-content>
              <v-flex xs12 class="py-0">
                <v-row class="spending-info pa-0">
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="teal"
                      :typeCard="1"
                      :value1="653848668196"
                      :valueEur="41940260.94906992"
                      text="TOTAL BUDGET"
                      textColor="teal--text"
                      style="border-right: 1px solid #BDBDBD !important;"
                    ></summary-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="softRed"
                      textColor="softRed--text"
                      :typeCard="2"
                      :value1="441865665998"
                      :valueTotal="653848668196"
                      :valueEur="28342890.699037846"
                      text="TOTAL SPENDING IO"
                      style="border-right: 1px solid #BDBDBD !important;"
                    ></summary-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="bluePurple"
                      textColor="bluePurple--text"
                      :typeCard="3"
                      :value1="211983002198"
                      :valueTotal="653848668196"
                      :valueEur="13597370.250032071"
                      text="TOTAL REMAINING BUDGET"
                    ></summary-amount>
                  </v-col>
                </v-row>
              </v-flex>
            </v-expansion-panel-content>
            <v-expansion-panel-header class="py-2">
              <template v-slot:actions class="mx-auto">
                <v-icon
                  color="bluedarken"
                  style="font-size: 23px !important;"
                  class="mx-auto"
                >
                  keyboard_arrow_down
                </v-icon>
              </template>
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
      <!-- /summary total amount -->
    </v-container>

    <!-- tampilan finance verifier -->
    <!-- button tanpa tab -->
    <v-col cols="12" class="white pt-0">
      <v-row class="px-8">
        <v-spacer />
        <v-menu
          v-if="hasPermission('create_budget', 'create') && page == 'budgeting'"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="btn-download-spending-byBo"
              class="white--text pb-0 mt-2 mr-3"
              depressed
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              Add/Cut Budget
            </v-btn>
          </template>

          <v-list>
            <v-list-item :to="{ name: 'reportAdd' }">
              <v-list-item-title>
                <!-- <v-icon left>add</v-icon> -->
                Add New Budget
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'reportAddCut' }">
              <v-list-item-title>
                Add/Cut Budget
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <advance-filter
          :title="'consolidate'"
          v-if="page == 'report'"
          :isDownload="false"
          @getFiltered="getFiltered"
        />
        <v-btn
          v-if="page == 'report' && hasPermission('create_spending', 'create')"
          id="btn-add"
          depressed
          color="primary"
          class="white--text f-14 lh-17 pb-0 mt-2 mr-3"
          @click="addIO()"
        >
          <v-icon left dark>add</v-icon>Add IO
        </v-btn>
        <advance-filter
          :title="page"
          :isDownload="page === 'report' ? true : false"
          v-if="!isLoggedInAsBO"
          @getFiltered="getFiltered"
        />
        <date-picker
          v-model="year"
          @change="getData()"
          type="year"
          placeholder="Filter"
          format="YYYY"
          class="dashSearch filterSearch mt-2"
          style="width: 135px !important;"
        >
        </date-picker>
      </v-row>
    </v-col>
    <!-- /button -->
    <!-- card divisi -->
    <card-group
      ref="cardGroup"
      :itemGroup="items"
      :year="year"
      :page="page"
      :fromDetail="fromDetail"
      :ioNumber="io"
      @getData="getData"
    />
    <!-- /tampilan finance verifier -->
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import ACLMixin from '@/mixins/ACLMixin';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import summaryAmount from '@/components/summaryAmount';
import CardGroup from '@/components/SpendingReport/CardGroup';
import advanceFilter from '@/components/advanceFilter/DynamicFilter';
import Swal from 'sweetalert2';
import moment from 'moment';
// import VueScrollTo from 'vue-scrollto';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'summary-amount': summaryAmount,
    'card-group': CardGroup,
    'advance-filter': advanceFilter
  },
  mixins: [ACLMixin, LoginAsMixin],
  props: ['yearIo', 'io', 'boIo'],
  data() {
    return {
      breadcrumbs: [
        {
          text: 'SPENDING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'SPENDING REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      progressDialogLoading: false,
      filterBy: [],
      panelSummary: [],
      year: new Date(),
      panel: false,
      tab: null,
      page: 'report',
      divList: [
        {
          id: '1',
          name: 'Marketing',
          totalBudget: 459523918196,
          totalBudgetEuro: 29475556.010006413,
          totalSpending: 423333549236,
          totalSpendingEuro: 27154172.497498397,
          remaining: 36190368960,
          remainingEuro: 2321383.512508018,
          status: 'approved',
          group: [
            {
              name: 'House & Budget Owner',
              value: 'house',
              listGroup: [
                {
                  name: 'House & Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 1,
                      name: 'Red House',
                      type: 'house',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000,
                      level: 1
                    },
                    {
                      id: 2,
                      name: 'Blue House',
                      level: 1,
                      type: 'house',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 3,
                      name: 'Yellow House',
                      level: 1,
                      type: 'house',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 4,
                      name: 'Bebelac GUM',
                      level: 1,
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 5,
                      name: 'SGM BUNDA',
                      level: 1,
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                },
                {
                  name: 'Department',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 10,
                      name: 'Consumer Experience & Communication',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 11,
                      name: 'Connection',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 12,
                      name: 'S&I',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 8,
                      name: 'SGM',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 9,
                      name: 'Bebelac',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 35,
                      name: 'Blue House',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                },
                {
                  name: 'Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 56,
                      name: 'Test Group 3-A',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 59,
                      name: 'Test Group 3-B',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 58,
                      name: 'Connection Child',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 57,
                      name: 'Sub Connection',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                }
              ]
            },
            {
              name: 'Department',
              value: 'department',
              listGroup: [
                {
                  name: 'Department',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 10,
                      name: 'Consumer Experience & Communication',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 11,
                      name: 'Connection',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 12,
                      name: 'S&I',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 8,
                      name: 'SGM',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 9,
                      name: 'Bebelac',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 35,
                      name: 'Blue House',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                },
                {
                  name: 'Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 56,
                      name: 'Test Group 3-A',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 59,
                      name: 'Test Group 3-B',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 58,
                      name: 'Connection Child',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 57,
                      name: 'Sub Connection',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                }
              ]
            },
            {
              name: 'Budget Owner',
              value: 'budgetOwner',
              listGroup: [
                {
                  name: 'Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 56,
                      name: 'Test Group 3-A',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 59,
                      name: 'Test Group 3-B',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 58,
                      name: 'Connection Child',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 57,
                      name: 'Sub Connection',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 2,
          name: 'HN',
          totalBudget: 459523918196,
          totalBudgetEuro: 29475556.010006413,
          totalSpending: 423333549236,
          totalSpendingEuro: 27154172.497498397,
          remaining: 36190368960,
          remainingEuro: 2321383.512508018,
          status: 'approved',
          group: [
            {
              name: 'Department',
              value: 'dept',
              listGroup: [
                {
                  name: 'Department',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 1,
                      name: 'Red House',
                      type: 'house',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000,
                      level: 1
                    },
                    {
                      id: 2,
                      name: 'Blue House',
                      level: 1,
                      type: 'house',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 3,
                      name: 'Yellow House',
                      level: 1,
                      type: 'house',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 4,
                      name: 'Bebelac GUM',
                      level: 1,
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 5,
                      name: 'SGM BUNDA',
                      level: 1,
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                },
                {
                  name: 'Department',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 10,
                      name: 'Consumer Experience & Communication',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 11,
                      name: 'Connection',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 12,
                      name: 'S&I',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 8,
                      name: 'SGM',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 9,
                      name: 'Bebelac',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 35,
                      name: 'Blue House',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                },
                {
                  name: 'Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 56,
                      name: 'Test Group 3-A',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 59,
                      name: 'Test Group 3-B',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 58,
                      name: 'Connection Child',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 57,
                      name: 'Sub Connection',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                }
              ]
            },
            {
              name: 'Category and Budget Owner',
              value: 'department',
              listGroup: [
                {
                  name: 'Category and Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 10,
                      name: 'Consumer Experience & Communication',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 11,
                      name: 'Connection',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 12,
                      name: 'S&I',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 8,
                      name: 'SGM',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 9,
                      name: 'Bebelac',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 35,
                      name: 'Blue House',
                      type: 'department',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                },
                {
                  name: 'Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 56,
                      name: 'Test Group 3-A',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 59,
                      name: 'Test Group 3-B',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 58,
                      name: 'Connection Child',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 57,
                      name: 'Sub Connection',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                }
              ]
            },
            {
              name: 'Budget Owner',
              value: 'budgetOwner',
              listGroup: [
                {
                  name: 'Budget Owner',
                  selectAll: false,
                  selected: [],
                  children: [
                    {
                      id: 56,
                      name: 'Test Group 3-A',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 59,
                      name: 'Test Group 3-B',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 58,
                      name: 'Connection Child',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    },
                    {
                      id: 57,
                      name: 'Sub Connection',
                      type: 'budget owner',
                      totalBudget: 3000000000,
                      totalSpending: 2000000000,
                      remaining: 1000000000
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      items: [],
      paramFilter: [],
      fromDetail: 'false',
      baseUrl: process.env.VUE_APP_BASE_URL,
      paramFiltered: [
        {
          divisionIds: [],
          houseIds: [],
          groupIds: [],
          budgetOwnerIds: []
        }
      ]
    };
  },
  destroyed() {
    this.$cookies.set('year', new Date());
  },
  watch: {
    $route() {
      this.checkRoute();
    },
    fromDetail(val) {
      localStorage.setItem('fromDetail', val);
    }
  },
  computed: {
    yearInfo() {
      return moment(this.year).format('YYYY');
    }
  },
  mounted() {
    this.profile_id = localStorage.getItem('profile_id');
    this.checkRoute();
  },
  methods: {
    async checkRoute() {
      this.filterBy = [];
      let path = this.$route.fullPath;
      let page = path.split('/').join('');
      this.fromDetail = localStorage.getItem('fromDetail');
      let prevYear = localStorage.getItem('prevYear');
      this.paramFilter = JSON.parse(localStorage.getItem('prevFilter')) || [];
      let prevIO = JSON.parse(localStorage.getItem('prevIO')) || [];
      this.year = prevYear ? new Date(prevYear) : this.year;
      if (page == 'spendingreport') {
        this.page = 'report';
        if (this.fromDetail == 'true') {
          this.items = this.paramFilter;
          for (let i = 0; i < prevIO.length; i++) {
            await this.$refs.cardGroup.getIO(prevIO[i], this.fromDetail, i);
          }
        } else {
          await this.getData();
        }
        this.fromDetail = 'false';
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          // let redirect = '#id' + JSON.parse(localStorage.getItem('idItem'));
          // VueScrollTo.scrollTo(redirect);
          // localStorage.removeItem('idItem');
        }, 5000);
        this.breadcrumbs[0].text = 'SPENDING';
        this.breadcrumbs[1].text = 'SPENDING REPORT';
      } else if (page == 'spendingapproval') {
        // let prevYear = this.$cookies.get('year');
        // this.year = prevYear ? new Date(prevYear) : this.year;
        this.page = 'approval';
        if (this.fromDetail == 'true') {
          this.items = this.paramFilter;
          for (let i = 0; i < prevIO.length; i++) {
            await this.$refs.cardGroup.getIO(prevIO[i], this.fromDetail, i);
          }
        } else {
          await this.getData();
        }
        this.fromDetail = 'false';
        localStorage.setItem('fromDetail', false);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {}, 5000);
        this.breadcrumbs[0].text = 'SPENDING';
        this.breadcrumbs[1].text = 'SPENDING APPROVAL';
      } else if (page == 'budgetingreport') {
        this.page = 'budgeting';
        this.getData();
        this.breadcrumbs[0].text = 'BUDGETING';
        this.breadcrumbs[1].text = 'BUDGET REPORT';
      } else if (page.includes('spendingreportsearch')) {
        this.paramFiltered = [
          {
            divisionIds: [],
            houseIds: [],
            groupIds: [],
            budgetOwnerIds: [this.boIo]
          }
        ];
        this.page = 'report';
        this.fromDetail = localStorage.getItem('fromDetail');
        this.paramFilter = JSON.parse(localStorage.getItem('prevFilter')) || [];
        this.year = new Date(this.yearIo, 1, 1);
        let params = {
          type: 'report',
          param: this.paramFiltered,
          info: ''
        };
        await this.getFiltered(params);
        this.fromDetail = 'false';
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {}, 5000);
        this.breadcrumbs[0].text = 'SPENDING';
        this.breadcrumbs[1].text = 'SPENDING REPORT';
      } else if (page.includes('spendingapprovalsearch')) {
        this.paramFiltered = [
          {
            divisionIds: [],
            houseIds: [],
            groupIds: [],
            budgetOwnerIds: [this.boIo]
          }
        ];
        this.year = new Date(this.yearIo, 1, 1);
        this.page = 'approval';
        let params = {
          type: 'report',
          param: this.paramFiltered,
          info: ''
        };
        await this.getFiltered(params);
        this.breadcrumbs[0].text = 'SPENDING';
        this.breadcrumbs[1].text = 'SPENDING APPROVAL';
      }
    },
    getData() {
      this.progressDialogLoading = true;
      let type = this.page;
      let params = {
        type: type,
        profileId: localStorage.getItem('profile_id'),
        year: moment(this.year).format('YYYY'),
        filter: this.paramFiltered
      };
      return this.$store
        .dispatch('spendingDynamic/getListDivision', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.items = data.data.map((item, index) => {
              return {
                ...item,
                indexCard: index,
                panel: false,
                tab: null,
                group: []
              };
            });
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    addIO() {
      localStorage.setItem('isAdhoc', false);
      this.$router.push({
        name: 'spendingCreate'
      });
    },
    getFiltered(val) {
      this.filterBy = val.info;
      this.paramFiltered = val.param;
      if (val.type === 'download') {
        this.downloadData();
      } else {
        if (val.param.length > 0) {
          this.progressDialogLoading = true;
          let params = {
            type: this.page,
            profileId: localStorage.getItem('profile_id'),
            year: moment(this.year).format('YYYY'),
            filter: this.paramFiltered
          };
          return this.$store
            .dispatch('spendingDynamic/getFiltered', params)
            .then(data => {
              this.progressDialogLoading = false;
              if (data.code === 200) {
                this.items = data.data.map((item, index) => {
                  return {
                    ...item,
                    indexCard: index,
                    panel: false,
                    tab: null,
                    group: []
                  };
                });
              } else {
                if (data) {
                  Swal.fire(
                    'Failed!',
                    data.response.data.data.message.text_en,
                    'error'
                  );
                } else {
                  Swal.fire('Failed!', 'Please try again', 'error');
                }
              }
            })
            .catch(err => {
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            });
        } else {
          this.getData();
        }
      }
    },
    downloadData() {
      let filters = '';
      if (this.paramFiltered.length > 0) {
        for (var i = 0; i < this.paramFiltered.length; i++) {
          filters +=
            `&filter[]={"divisionIds":[${this.paramFiltered[i].divisionIds}],` +
            `"houseIds":[${this.paramFiltered[i].houseIds}],` +
            `"groupIds":[${this.paramFiltered[i].groupIds}],` +
            `"budgetOwnerIds":[${this.paramFiltered[i].budgetOwnerIds}]}`;
        }
      }
      let year = moment(this.year).format('YYYY');
      let profile_id = localStorage.getItem('profile_id');
      let type = this.page;
      window.open(
        this.baseUrl +
          '/v2/report/filter?profileId=' +
          profile_id +
          '&year=' +
          year +
          '&type=' +
          type +
          '&export=yes' +
          filters +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>

<style>
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
</style>
